module.exports = __webpack_public_path__ + "img/logo.6cec6a87.png";